namespace GeniuzPOS.Inventory {
    export interface IcStockReceiveRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockFrom?: string;
        SupplName?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ReceiveDtList?: IcStockReceiveDtRow[];
        CancelFg?: CancelFgstatus;
    }

    export namespace IcStockReceiveRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockReceive';
        export const lookupKey = 'Inventory.IcStockReceive';

        export function getLookup(): Q.Lookup<IcStockReceiveRow> {
            return Q.getLookup<IcStockReceiveRow>('Inventory.IcStockReceive');
        }
        export const deletePermission = '2Inventory:รายการ:รับเข้า:Modify';
        export const insertPermission = '2Inventory:รายการ:รับเข้า:Modify';
        export const readPermission = '2Inventory:รายการ:รับเข้า:View';
        export const updatePermission = '2Inventory:รายการ:รับเข้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockFrom = "StockFrom",
            SupplName = "SupplName",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ReceiveDtList = "ReceiveDtList",
            CancelFg = "CancelFg"
        }
    }
}
